const PAYMENT_GROUP_NAMES = Object.freeze({
  cardInStore: 'cashUp.payoutReport.groupNames.cardInStore',
  cardOnline: 'cashUp.payoutReport.groupNames.cardOnline',
  tips: 'cashUp.payoutReport.groupNames.tips',
  refundAmexFee: 'cashUp.payoutReport.groupNames.refundAmexFee',
});

export default PAYMENT_GROUP_NAMES;
